import React from "react";

import "../styles/loading.scss";

const Loading = () => {
    return (
        <div className="loading__wrap">
            <div className="loading">
                <div className="loading__dot"></div>
                <div className="loading__dot"></div>
                <div className="loading__dot"></div>
            </div>
        </div>
    )
}

export default Loading;